module.exports = __webpack_public_path__ + "img/stas-main-io.01a16ae2.jpg";